import React from 'react';
import { Link } from 'react-router-dom';

function DefaultButton({
  text,
  link,
  dark,
  buttonClass,
  ariaLabelledby,
  id,
}) {
  const baseClass = `page-link ${
    dark
      ? 'progress-button-light border-slate-50 text-slate-50'
      : 'border-black text-black progress-button-dark'
  } px-8 py-2 uppercase border text-center flex  items-center justify-center transition duration-300 ease-in-out ${buttonClass !== '' ? buttonClass : 'lg:w-1/2'}`;

  if (link?.startsWith('http')) {
    return (
      <a
        id={id}
        href={link}
        target="_blank"
        rel="noreferrer"
        className={baseClass}
        aria-labelledby={ariaLabelledby}
      >
        {text}
      </a>
    );
  }

  return (
    <Link
      id={id}
      to={link}
      className={baseClass}
      aria-labelledby={ariaLabelledby}
    >
      {text}
    </Link>
  );
}

export default DefaultButton;